import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICompte } from "../../models/interfaces/ICompte";


const initialState: ICompte = {
    Actif:undefined,
    Id: undefined,
    IdPersonne: undefined,
    IdCivilite: undefined,
    Telephone: undefined,
    Email:undefined,
    Login:undefined,
    Nom:undefined,
    Prenom:undefined,
    IdTypeCompte:undefined,
    Connected:undefined,
    IdSociete:undefined,
    IdAlerteParution:undefined,
    Modules:undefined,
    RecevoirCommunications: undefined,
    RecevoirCommunicationsPartenaires: undefined,
    //DateCreation: new Date(),
    //DateModification: new Date()
};





const compteSlice = createSlice({
    name: "compte",
    initialState,
    reducers: {
        setErrorCompte(state) {
            state.Actif = initialState.Actif;
            state.Id = initialState.Id;
            state.IdPersonne = initialState.IdPersonne;
            state.IdCivilite = initialState.IdCivilite;
            state.Telephone = initialState.Telephone;
            state.Login = initialState.Login;
            state.Email = initialState.Email;
            state.Nom = initialState.Nom;
            state.Prenom = initialState.Prenom;
            state.IdTypeCompte = initialState.IdTypeCompte;
            state.Connected = false;
            state.IdSociete = initialState.IdSociete;
            state.IdAlerteParution = initialState.IdAlerteParution;
            state.Modules = initialState.Modules;
            state.RecevoirCommunications = initialState.RecevoirCommunications;
            state.RecevoirCommunicationsPartenaires = initialState.RecevoirCommunicationsPartenaires;
        },
        setCompte(state, action: PayloadAction<ICompte>) {
            state.Actif = action.payload.Actif;
            state.Id = action.payload.Id;
            state.IdPersonne = action.payload.IdPersonne;
            state.IdCivilite = action.payload.IdCivilite;
            state.Telephone = action.payload.Telephone;
            state.Login = action.payload.Login;
            state.Email = action.payload.Email;
            state.Nom = action.payload.Nom;
            state.Prenom = action.payload.Prenom;
            state.IdTypeCompte = action.payload.IdTypeCompte;
            state.Connected = true; //action.payload.Login !== undefined ? true : false;
            state.IdSociete = action.payload.IdSociete;
            state.IdAlerteParution = action.payload.IdAlerteParution;
            state.Modules = action.payload.Modules;
            state.RecevoirCommunications = action.payload.RecevoirCommunications;
            state.RecevoirCommunicationsPartenaires = action.payload.RecevoirCommunicationsPartenaires;
            //state.DateCreation = action.payload.DateCreation;
            //state.DateModification = action.payload.DateModification;
          },
          resetCompte(state) {
            state.Actif = initialState.Actif;
            state.Id = initialState.Id;
            state.IdPersonne = initialState.IdPersonne;
            state.IdCivilite = initialState.IdCivilite;
            state.Telephone = initialState.Telephone;
            state.Email = initialState.Email;
            state.Login = initialState.Login;
            state.Nom = initialState.Nom;
            state.Prenom = initialState.Prenom;
            state.IdTypeCompte = initialState.IdTypeCompte;
            state.Connected = initialState.Connected;
            state.IdSociete = initialState.IdSociete;
            state.IdAlerteParution = initialState.IdAlerteParution;
            state.Modules = initialState.Modules;
            state.RecevoirCommunications = initialState.RecevoirCommunications;
            state.RecevoirCommunicationsPartenaires = initialState.RecevoirCommunicationsPartenaires;           
            //state.DateCreation = initialState.DateCreation;
            //state.DateModification = initialState.DateModification;
          },
    }
}
)
export const { setErrorCompte,setCompte, resetCompte } = compteSlice.actions;
export default compteSlice.reducer;